import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ArticleCard from "../components/ArticleCard";
import { api } from "../lib/api";
import { CATEGORIES, getCategory } from "../lib/categories";

export default function CategoryPage({ featuredPage = false }) {
  const { slug } = useParams();
  const catSlug = featuredPage ? "a-la-une" : slug;
  const cat = getCategory(catSlug);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [sub, setSub] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = `${cat.name} — Le Véridique`;
    setLoading(true);
    setSub(null);
  }, [catSlug]); // eslint-disable-line

  useEffect(() => {
    setLoading(true);
    const params = { limit: 60 };
    if (featuredPage) params.featured = true;
    else {
      params.category = catSlug;
      if (sub) params.subcategory = sub;
    }
    api.get("/articles", { params }).then((r) => {
      setItems(r.data.articles || []);
      setTotal(r.data.total || 0);
    }).finally(() => setLoading(false));
  }, [catSlug, sub, featuredPage]);

  const lead = items[0];
  const rest = items.slice(1);

  return (
    <div className="App">
      <Header />
      <div className="border-b-4" style={{ borderColor: cat.color }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
          <span className="meta-label" style={{ color: cat.color }}>Rubrique</span>
          <h1 className="font-headline text-4xl sm:text-5xl font-black text-[#0A0A0A] mt-1">{cat.name}</h1>
          <p className="meta-label text-slate-400 mt-2">{total} article{total > 1 ? "s" : ""}</p>

          {cat.subs && cat.subs.length > 0 && (
            <div className="flex flex-wrap gap-2 mt-5">
              <button onClick={() => setSub(null)} data-testid="subfilter-all"
                className={`px-4 py-1.5 rounded-full font-sub text-sm border transition-colors ${!sub ? "bg-[#0F172A] text-white border-[#0F172A]" : "border-[#E2E8F0] text-slate-600 hover:border-[#0F172A]"}`}>
                Tout
              </button>
              {cat.subs.map((s) => (
                <button key={s} onClick={() => setSub(s)} data-testid={`subfilter-${s}`}
                  className={`px-4 py-1.5 rounded-full font-sub text-sm border transition-colors ${sub === s ? "text-white border-transparent" : "border-[#E2E8F0] text-slate-600 hover:border-[#0F172A]"}`}
                  style={sub === s ? { background: cat.color } : {}}>
                  {s}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {loading && <div className="py-20 text-center meta-label text-slate-400">Chargement…</div>}
        {!loading && items.length === 0 && (
          <div className="py-20 text-center">
            <p className="font-body text-slate-500">Aucun article dans cette rubrique pour le moment.</p>
            <Link to="/" className="meta-label text-[#E11D48] mt-3 inline-block">← Retour à l'accueil</Link>
          </div>
        )}
        {!loading && lead && (
          <>
            <div className="mb-10"><ArticleCard article={lead} variant="hero" /></div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {rest.map((a) => <ArticleCard key={a.id} article={a} />)}
            </div>
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}
